import React, { useEffect, useState } from "react";
import "./LoanTypes.scss";
import { 
    Box, 
    Typography, 
    Button,
    Tab,
    Tabs
} from "@mui/material";
import { commonRunQuery, loansCreateLoanType, loansUpdateLoanType } from "../../../../util/API/loans";
import CustomLoansForm from "../../../../components/UI/CustomLoansForm/CustomLoansForm";
import LoanSetupTable from "../../../../components/LoanSetupTable/LoanSetupTable";
import { useDispatch } from "react-redux";
import { setNewConstants } from "../../../../store/redux/constants";
import LoanTypesDetailsView from "../../../../components/LoanTypesDetailsView/LoanTypesDetailsView";
import LoanLangTagsTable from "../../../../components/LoanLangTagsTable/LoanLangTagsTable";
import { setAsArray } from "../../../../util/utilfunctions/utilFunctions";

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            style={{
                backgroundColor: "white",
            }}
            
        >
            {value === index && (
            <Box sx={{ p: 3 }} className="loans-setup-custom-tab-container">
               {children}
            </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
}

const LoanTypes = ({loanTypes, setAlert, setAlertOpen, selectedProductId}) => {
    const [formValues, setFormValues] = useState(null);
    const [loanProductsArr, setLoanProductsArr] = useState([]);
    const [value, setValue] = useState(0);
    const [loanTypeConfig, setLoanTypeConfig] = useState({});
    const [loanTypeMsgTexts, setLoanTypeMsgTexts] = useState({});
    const [viewMode, setViewMode] = useState("table");
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [loanTypesArr, setLoanTypesArr] = useState([]);
    const [feeTableData, setFeeTableData] = useState([]);
    const [formattedLoanTypes, setFormattedLoanTypes] = useState([]);
    const [langIdTableData, setLangIdTableData] = useState([]);
    const [selectedLangId, setSelectedLangId] = useState(null);
    const [displayLangTagDetails, setDisplayLangTagDetails] = useState(false);
    const [displayLangTagDetailsArray, setDisplayLangTagDetailsArray] = useState([]);
    
    const dispatch = useDispatch();
    console.log("selectedProductId=======================",selectedProductId);

    useEffect(()=> {
        console.log("selectedProductIdddddd=======================",selectedProductId);
        console.log("loanTypes=======================",loanTypes);

        if (loanTypes.length > 0) {
            const formattedLoanTypes = loanTypes
                .filter(item => item.loantypes.loantype !== selectedProductId)
                .map(item => ({
                    key: item.loantypes.loantype,
                    value: item.loantypes.loantype,
                    label: item.loantypes.loandesc,
                }));
    
            setFormattedLoanTypes(formattedLoanTypes);
            console.log("formattedLoanTypes=======================", formattedLoanTypes);
        }
        
        setLoanTypesArr(loanTypes)
        getAllLoanProducts();
        getFeeTableData();
    }, []);

    useEffect(()=> {
        console.log("formattedLoanTypesssssssssss=======================", formattedLoanTypes);
        const tempLoanTypes = [{
            "key": "0",
            "value": "0",
            "label": "None"
        }]
        dispatch(setNewConstants({ formSelectData: { productid: loanProductsArr, purchasetableid: feeTableData, latefeetableid: feeTableData, nextloantype:formattedLoanTypes?.length > 0 ? formattedLoanTypes : tempLoanTypes } }));
    },[loanProductsArr, feeTableData, formattedLoanTypes])

    const getAllLoanTypes = async() => {
        try {
            let response = await commonRunQuery(272, selectedProductId);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const loanTypesArray = Array.isArray(response?.data?.body?.record) ? response?.data?.body?.record : [response?.data?.body?.record];
                setLoanTypesArr(loanTypesArray);
                // console.log("getAllLoanTypes_formattedLoanTypes=======================",loanTypesArray);

                // const formattedLoanTypes = loanTypesArray.map(item => ({
                //     key: item.loantypes.loantype,
                //     value: item.loantypes.loantype,
                //     label: item.loantypes.loandesc,
                // }));
                // console.log("getAllLoanTypes_formattedLoanTypes=======================",formattedLoanTypes);
            } else {
                setLoanTypesArr([]);
            }
        } catch (error) {
            console.log("getAllCategories_error=======================",error);
        }
    }

    const getAllLoanProducts = async () => {
        try {
            let response = await commonRunQuery(268, "");
            if (
                response?.data?.header?.callStatus === "1" &&
                response?.data?.header?.reccount !== "0"
            ) {
                const loanProductsArray = Array.isArray(response?.data?.body?.record)
                    ? response?.data?.body?.record
                    : [response?.data?.body?.record];
    
                const formattedLoanProducts = loanProductsArray.map(item => ({
                    key: item.lp.productid,
                    value: item.lp.productid,
                    label: item.lp.name,
                }));
    
                setLoanProductsArr(formattedLoanProducts);
                console.log("formattedLoanProducts=======================", formattedLoanProducts);
            } else {
                setLoanProductsArr([]);
            }
        } catch (error) {
            console.log("getAllCategories_error=======================", error);
        }
    };

    const getFeeTableData = async () => {
        try {
            let response = await commonRunQuery(273, "");
            if (
                response?.data?.header?.callStatus === "1" &&
                response?.data?.header?.reccount !== "0"
            ) {
                const feeDataArray = Array.isArray(response?.data?.body?.record)
                    ? response?.data?.body?.record
                    : [response?.data?.body?.record];
    
                const formattedFeesDataArr = feeDataArray.map(item => ({
                    key: item.purchasefeetable?.tableid,
                    value: item.purchasefeetable?.tableid,
                    label: item.purchasefeetable?.description,
                }));
    
                setFeeTableData(formattedFeesDataArr);
                console.log("formattedFeesDataArr=======================", formattedFeesDataArr);
            } else {
                setFeeTableData([]);
            }
        } catch (error) {
            console.log("getAllCategories_error=======================", error);
        }
    }

    const columns = [
        {
            label: 'Type Id',
            getValue: (row) => row?.loantypes?.loantype ?? ''
        },
        {
            label: 'Description',
            getValue: (row) => row?.loantypes?.loandesc?.toString().trim() ? row?.loantypes?.loandesc : "-"
        },
        {
            label: 'Flagging',
            getValue: (row) => row?.loantypes?.flagging == 1 ? 'Yes' : 'No'
        },
        {
            label: 'Flagging Days',
            getValue: (row) => row?.loantypes?.flaggingdays ?? ''
        },
        {
            label: 'Opt In',
            getValue: (row) => row?.loantypes?.optin ?? ''
        },
        {
            label: 'Is flagged loan a due loan?',
            getValue: (row) => row?.loantypes?.isflaggedloandue == 1 ? 'Yes' : 'No'
        },
    ];

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const TIME_GRANULARITY_MAP = {
        "0": "End of Day Calculation",
        "1": "24 Hours Calculation",
    };
      
    const TERM_INTEREST_ALLOCATION_MAP = {
        "0": "Diminishing Allocation",
        "1": "Flat Allocation",
        "2": "Flat Principal",
    };
      
    const FEE_CALCULATION_MODE_MAP = {
        "1": "Original Principal",
        "2": "Outstanding Principal",
        "3": "Total Outstanding",
    };
      
    const DISBURSEMENT_TYPE_MAP = {
        "1": "Full Principal",
        "2": "Principal - Interest",
    };

    const transformLoanTypeConfig = (recordData) => {
        if (!recordData) return {};
      
        const { lt, pft1, pft2, nxt, record } = recordData;
      console.log("record------------",record);
        return {
          // 🔝 Move these to top (keys unchanged)
          LoanType: lt.LoanType,
          LoanDescription: lt.LoanDescription,
      
          // 🔁 Replace IDs with descriptions (same key name)
          PurchaseTableId: pft1?.PurchaseTableDescription ?? lt.PurchaseTableId,
          LateFeeTableId: pft2?.LateFeeTableDescription ?? lt.LateFeeTableId,
      
          TermInterestAllocationType:
            TERM_INTEREST_ALLOCATION_MAP[lt.TermInterestAllocationType] ??
            lt.TermInterestAllocationType,

          // 🔄 Translated enum values (same keys)
          TimeGranularity:
            TIME_GRANULARITY_MAP[lt.TimeGranularity] ?? lt.TimeGranularity,
      
          // 📦 Rest of the fields unchanged
          DisplayOrderNumber: lt.DisplayOrderNumber,
          FeeFixed: lt.FeeFixed,
          FeePercentage: lt.FeePercentage,
          FeeTax: lt.FeeTax,
          Flagging: lt.Flagging,
          FlaggingDays: lt.FlaggingDays,
          FlaggingWarningDays: lt.FlaggingWarningDays,
          GracePeriodDays: lt.GracePeriodDays,
          IgnoreHolidays: lt.IgnoreHolidays,
          IgnoreNextBusinessDay: lt.IgnoreNextBusinessDay,
          IncludeFeesInEligibilityCheck: lt.IncludeFeesInEligibilityCheck,
          IsFlaggedLoanDue: lt.IsFlaggedLoanDue,
          MaxActiveLoans: lt.MaxActiveLoans,
          NextLoanType: nxt.NextLoanDescription ? nxt.NextLoanDescription : 'N/A',
        //   NextLoanType: lt.NextLoanType,
          NumberOfDays: lt.NumberOfDays,
          NumberOfDueDays: lt.NumberOfDueDays,
          OptIn: lt.OptIn,
          OptOut: lt.OptOut,
        ProductId: lt.ProductId,
          Restrictive: lt.Restrictive,
          SelectableByUser: lt.SelectableByUser,
          FeeCalculationMode:
            FEE_CALCULATION_MODE_MAP[lt.FeeCalculationMode] ??
            lt.FeeCalculationMode,
          StopCalculatingAfterDays: lt.StopCalculatingAfterDays,
          DisbursementType: DISBURSEMENT_TYPE_MAP[lt.DisbursementType] ?? lt.DisbursementType,
          PaymentTerm: record ? record?.PlanDescriptions : 'N/a',
          structuredData: value
        //   lt,
        //   pft1,
        //   pft2,
        };
    };

    const handleViewDetails = async(rowData) => {
        console.log("rowData=======================",rowData?.loantypes?.loantype);
        setViewMode("view")

        try {
            const response = await commonRunQuery(271,rowData?.loantypes?.loantype);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                // const loanTypesConfigArray = Array.isArray(response?.data?.body?.record) ? response?.data?.body?.record : [response?.data?.body?.record];
                const transformedData = transformLoanTypeConfig(
                    response?.data?.body?.record
                );

                console.log("loanTypesConfigArray1=======================",response?.data?.body?.record);
                setLoanTypeConfig(transformedData);
                // setLoanTypeConfig(response?.data?.body?.record);
            } else {
                setLoanTypeConfig({});
            }

            const response2 = await commonRunQuery(270,rowData?.loantypes?.loantype);
            if ( response2?.data?.header?.callStatus === "1" && response2?.data?.header?.reccount !== "0" ) {
                // const loanTypesMsgTextsArray = Array.isArray(response2?.data?.body?.record) ? response2?.data?.body?.record : [response2?.data?.body?.record];
                setLoanTypeMsgTexts(response2?.data?.body?.record?.loantypes);
                console.log("loanTypesMsgTextsArray2=======================",response2?.data?.body?.record?.loantypes);
            } else {
                setLoanTypeMsgTexts({});
            }
        } catch (error) {
            console.log("getAllCategories_error=======================",error);
        }
    }

    const handleEdit = async(rowData) => {
        console.log("rowData--------------",rowData);
        console.log("rowData--------------",rowData?.record?.plandesc_array);
        const arrayValue = rowData?.record?.plandesc_array ? rowData?.record?.plandesc_array.split(",") : [];
        const rowTempData = {
            ...rowData,
            loantypes: {
                ...rowData.loantypes,
                paymentterms: arrayValue
            }
        };
        setSelectedProduct(rowTempData);
        // setSelectedProduct(rowData);

        try {
            let response = await commonRunQuery(272, rowData?.loantypes?.productid);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const loanTypesArray = Array.isArray(response?.data?.body?.record) ? response?.data?.body?.record : [response?.data?.body?.record];
                setLoanTypesArr(loanTypesArray);
                console.log("handleEdit_loanTypesArrayyyyy=======================",loanTypesArray);

                if (loanTypesArray.length > 0) {
                    const formattedLoanTypes = loanTypesArray
                        .filter(item => (item.loantypes.loantype !== rowData?.loantypes?.productid ) && (item.loantypes.loantype !== rowData?.loantypes?.loantype) )
                        .map(item => ({
                            key: item.loantypes.loantype,
                            value: item.loantypes.loantype,
                            label: item.loantypes.loandesc,
                        }));

                    const staticOption = {
                        key: "0",
                        value: "0",
                        label: "None"
                    };
                    
                    const updatedFormattedLoanTypes = [staticOption, ...formattedLoanTypes];
            
                    setFormattedLoanTypes(updatedFormattedLoanTypes);
                    console.log("formattedLoanTypessssssssss=======================", updatedFormattedLoanTypes);
                }
            } else {
                setLoanTypesArr([]);
            }
        } catch (error) {
            console.log("getAllCategories_error=======================",error);
        }


        // if(loanTypes.length>0) {
        //     const formattedLoanTypes = loanTypes
        //     .filter(item => item.loantypes.loantype !== rowData?.loantypes?.loantype)
        //     .map(item => ({
        //         key: item.loantypes.loantype,
        //         value: item.loantypes.loantype,
        //         label: item.loantypes.loandesc,
        //     }));

        //     setFormattedLoanTypes(formattedLoanTypes);
        //     console.log("formattedLoanTypes=======================",formattedLoanTypes);
        // }

        setViewMode("edit");
    };

    const handleLoanTypeCreate = async(submittedValue) => {
        console.log("Submitted Dataaaaaa================", submittedValue);
        try {
            const response = await loansCreateLoanType(
                submittedValue?.location,
                submittedValue?.timegranularity,
                submittedValue?.terminterestallocationtype,
                submittedValue?.stopcalculatingafterdays,
                submittedValue?.selectablebyuser,
                submittedValue?.restrictive,
                submittedValue?.purchasetableid,
                submittedValue?.productid,
                submittedValue?.optout,
                submittedValue?.optin,
                submittedValue?.numberofdays,
                submittedValue?.noofduedays,
                submittedValue?.nextloantype,
                submittedValue?.maxactiveloans,
                submittedValue?.loandesc,
                submittedValue?.latefeetableid,
                submittedValue?.isflaggedloandue,
                submittedValue?.includefeesineligibilitycheck,
                submittedValue?.ignorenextbusinessday,
                submittedValue?.ignoreholidays,
                submittedValue?.graceperioddays,
                submittedValue?.flaggingwaringdays,
                submittedValue?.flaggingdays,
                submittedValue?.flagging,
                0.00,
                0.00,
                0.00,
                submittedValue?.feecalculationmode,
                0,
                submittedValue?.disbursementtype,
                submittedValue?.unblocklangid,
                submittedValue?.optoutlangid,
                submittedValue?.optinlangid,
                submittedValue?.noteligiblelangid,
                submittedValue?.nexttierwarninglangid,
                submittedValue?.nexttiernotificationlangid,
                submittedValue?.loanrequestwarninglangid,
                submittedValue?.loanrequestconfirmationlangid,
                submittedValue?.loanpaymentconfirmationlangid,
                submittedValue?.loanlimitlangid,
                submittedValue?.latefeewarninglangid,
                submittedValue?.latefeelangid,
                submittedValue?.flagwarninglangid,
                submittedValue?.flaggedlangid,
                submittedValue?.blockedlangid,
                submittedValue?.paymentterms?.join(",") // newly added
            );

            if(response?.data?.header?.callStatus === "1") {
                setAlert({
                    showAlert: true,
                    message: "Loan type created successfully.",
                    severity: "success",
                    header: "Success",
                });
                setAlertOpen(true);

                getAllLoanTypes();
                setViewMode("table");
            }
        } catch (error) {
            setAlert({
                showAlert: true,
                message: "There was an error in creating loan type. " + error,
                severity: "error",
                header: "Error",
            });
        }
    }

    const handleLoanTypeUpdate = async(submittedValue) => {
        console.log("handleLoanTypeUpdate_Submitted Data================", submittedValue);
        try {
            const response = await loansUpdateLoanType(
                submittedValue?.location,
                submittedValue?.loantype,
                submittedValue?.timegranularity,
                submittedValue?.terminterestallocationtype,
                submittedValue?.stopcalculatingafterdays,
                submittedValue?.selectablebyuser,
                submittedValue?.restrictive,
                submittedValue?.purchasetableid,
                submittedValue?.productid,
                submittedValue?.optout,
                submittedValue?.optin,
                submittedValue?.numberofdays,
                submittedValue?.noofduedays,
                submittedValue?.nextloantype,
                submittedValue?.maxactiveloans,
                submittedValue?.loandesc,
                submittedValue?.latefeetableid,
                submittedValue?.isflaggedloandue,
                submittedValue?.includefeesineligibilitycheck,
                submittedValue?.ignorenextbusinessday,
                submittedValue?.ignoreholidays,
                submittedValue?.graceperioddays,
                submittedValue?.flaggingwaringdays,
                submittedValue?.flaggingdays,
                submittedValue?.flagging,
                0.00,
                0.00,
                0.00,
                submittedValue?.feecalculationmode,
                0,
                submittedValue?.disbursementtype,
                submittedValue?.unblocklangid,
                submittedValue?.optoutlangid,
                submittedValue?.optinlangid,
                submittedValue?.noteligiblelangid,
                submittedValue?.nexttierwarninglangid,
                submittedValue?.nexttiernotificationlangid,
                submittedValue?.loanrequestwarninglangid,
                submittedValue?.loanrequestconfirmationlangid,
                submittedValue?.loanpaymentconfirmationlangid,
                submittedValue?.loanlimitlangid,
                submittedValue?.latefeewarninglangid,
                submittedValue?.latefeelangid,
                submittedValue?.flagwarninglangid,
                submittedValue?.flaggedlangid,
                submittedValue?.blockedlangid,
                submittedValue?.paymentterms?.join(",")
            );

            if(response?.data?.header?.callStatus === "1") {
                setAlert({
                    showAlert: true,
                    message: "Loan type updated successfully.",
                    severity: "success",
                    header: "Success",
                });
                setAlertOpen(true);

                getAllLoanTypes();
                setViewMode("table");
            }
        } catch (error) {
            setAlert({
                showAlert: true,
                message: "There was an error in updating loan type. " + error,
                severity: "error",
                header: "Error",
            });
        }
    }

    const handleCreateLoanTypeBtnClick = async() => {
        console.log("formattedLoanTypes=======================",formattedLoanTypes);
        console.log("loanTypes=======================",loanTypes);
        console.log("selectedProductId=======================",selectedProductId);
        
        try {
            let response = await commonRunQuery(272, selectedProductId);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const loanTypesArray = Array.isArray(response?.data?.body?.record) ? response?.data?.body?.record : [response?.data?.body?.record];
                setLoanTypesArr(loanTypesArray);
                console.log("loanTypesArrayyyyy=======================",loanTypesArray);

                if (loanTypesArray.length > 0) {
                    const formattedLoanTypes = loanTypesArray
                        .filter(item => item.loantypes.loantype !== selectedProductId)
                        .map(item => ({
                            key: item.loantypes.loantype,
                            value: item.loantypes.loantype,
                            label: item.loantypes.loandesc,
                        }));

                    const staticOption = {
                        key: "0",
                        value: "0",
                        label: "None"
                    };
                    
                    const updatedFormattedLoanTypes = [staticOption, ...formattedLoanTypes];
                    setFormattedLoanTypes(updatedFormattedLoanTypes);
                    console.log("formattedLoanTypessssssssss=======================", updatedFormattedLoanTypes);
                }
            } else {
                setLoanTypesArr([]);
            }
        } catch (error) {
            console.log("getAllCategories_error=======================",error);
        }

        // dispatch(setNewConstants({ formSelectData: { nextloantype:formattedLoanTypes } }));
        setViewMode("create");
    }

    const handleLangIdSelect = async(langIdData) => {
        console.log("langIdData=======================",langIdData);
        setViewMode("viewLangIdTable");
        setSelectedLangId(langIdData);
        try {
            const response = await commonRunQuery(275,langIdData);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const langIdDataArray = Array.isArray(response?.data?.body?.record)
                    ? response?.data?.body?.record
                    : [response?.data?.body?.record];
                setLangIdTableData(langIdDataArray);
                console.log("langIdDataArray=======================",langIdDataArray);
            } else {
                setLangIdTableData([]);
            }
        } catch (error) {
            console.log("getAllCategories_error=======================",error);
        }
    }

    const verifyLangTagId = async(inputValue) => {
        console.log("verifyLangTagId=========",inputValue);
        try {
            const response = await commonRunQuery(275, inputValue);
            if(response?.data?.header?.callStatus == "1" && parseInt(response?.data?.header?.reccount) > 0) {
              const responseData = setAsArray(response?.data?.body?.record);
                console.log("verifyLangTagId_response-----------", responseData);
                setDisplayLangTagDetailsArray(responseData);
                setDisplayLangTagDetails(true);
            //   console.log("verifyLangTagId_responseData-----------", responseData);
            //   const formattedApps = responseData.map(item => ({
            //     label: item.apps.description + ` (${item.apps.appid})` ,  // What user sees
            //     appid: item.apps.appid         // What you use internally
            //   }));
            //   setAppsList(formattedApps);
            }
          } catch (error) {
            console.log("verifyLangTagId_error---------",error);
          } 
    }

    const formatText = (text) => {
        if (!text) return '';
      
        // Decode HTML entities
        const textarea = document.createElement('textarea');
        textarea.innerHTML = text;
        const decoded = textarea.value;
      
        return decoded;
    };

    return (
        <Box sx={{ p: 3 }} className="loan-types-container">
            <Box className="d-flex justify-content-between mb-2">
                <Typography
                    sx={{
                        fontFamily: "'Nunito'",
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: "21.4825px",
                        color: "#3A3A3A",
                    }}
                >
                    {viewMode == "create" ? "Loan Configuration" : viewMode == "edit" ? "Update Loan Type" : "Loan Types"}
                </Typography>

                {viewMode == "edit" || viewMode == "view" || viewMode == "create" ? 
                    <Button
                        className="fs-size-12 paiy-blue text-white"
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            setViewMode("table");
                            setSelectedProduct(null);
                            setValue(0);
                            setDisplayLangTagDetails(false);
                        }}
                    >
                        Return
                    </Button> 
                : viewMode == "table" ?
                    <Button
                        className="fs-size-12 paiy-blue text-white"
                        variant="contained"
                        color="primary"
                        onClick={ handleCreateLoanTypeBtnClick }
                    >
                        Create Loan Type
                    </Button>
                : null
                }
            </Box>
    
            {
                viewMode === "create" ? (
                    <Box>
                        <Box className="batch-tabs">
                            <Box sx={{ width: "100%" }}>
                                {/* <Box sx={{ borderRadius: "12px", backgroundColor: "#f8f8f8" }}>
                                    <Tabs
                                        value={value}
                                        onChange={handleChange}
                                        variant="scrollable"
                                        scrollButtons="auto"
                                        allowScrollButtonsMobile
                                        TabIndicatorProps={{ style: { display: "none" } }}
                                        sx={{
                                            "& .MuiTab-root": {
                                                textTransform: "capitalize",
                                                color: "#BCBCBC",
                                                fontFamily: "Inter",
                                                fontSize: 15,
                                                fontStyle: "normal",
                                                fontWeight: 400,
                                                lineHeight: "30px",
                                                backgroundColor: "#f8f8f8",
                                                width: "178px",
                                                "&.Mui-selected": {
                                                    backgroundColor: "white",
                                                    color: "#5523D2",
                                                    borderRadius: "6px 6px 0 0 !important",
                                                    textAlign: "center",
                                                    fontSize: 15,
                                                    fontStyle: "normal",
                                                    fontWeight: 600,
                                                    lineHeight: "30px",
                                                    borderBottom: 0,
                                                    borderBottomColor: "#FAC800",
                                                    borderBottomWidth: 4,
                                                },
                                            },
                                        }}
                                    >
                                        <Tab label="Configuration" {...a11yProps(0)} />
                                    </Tabs>
                                </Box> */}
                                {/* <CustomTabPanel value={value} index={0}> */}
                                
                                    <Box alignItems="center" gap={2} sx={{ maxWidth: 1200, mt: 4, p:2, pb:4, display: 'flex', flexDirection:'row', alignItems:'flex-start' }}>
                                        <Box sx={{width: '70%'}}>
                                            <CustomLoansForm
                                                formValues={formValues}
                                                formName={"createloantypes"}
                                                buttonText={"Submit"}
                                                onSubmit={handleLoanTypeCreate}
                                                loadingButtonText={"Creating Loan Type ..."}
                                                isCreate={true}
                                                isLoanProduct={true}
                                                initialValues={{
                                                    productid: selectedProductId
                                                }}
                                                verifyLangTagId={verifyLangTagId}
                                            />
                                        </Box>
                                        {displayLangTagDetails && 
                                            <Box sx={{ height:'100%', display:'flex', width:'30%', flexDirection:'column' }}>
                                                LangTag Details
                                                {
                                                    displayLangTagDetailsArray?.map((val, idx)=> {
                                                        console.log("displayLangTagDetailsArray-------", val);
                                                        return (
                                                            <Box sx={{ marginTop:'10px', whiteSpace: 'pre-line' }}>
                                                                <Typography>{formatText(val?.langtag?.label)}</Typography>
                                                            </Box>
                                                        )
                                                    })
                                                }
                                            </Box>
                                        }
                                    </Box>
                                {/* </CustomTabPanel> */}
                                {/* <CustomTabPanel value={value} index={1}>
                                    <Box alignItems="center" gap={2} sx={{ maxWidth: 800, mt: 2 }}>
                                        <CustomLoansForm
                                            formValues={formValues}
                                            formName={"createloantypemessagetexts"}
                                            buttonText={"Submit"}
                                            onSubmit={handleSubmit}
                                            loadingButtonText={"Creating Loan Type ..."}
                                        />
                                    </Box>
                                </CustomTabPanel> */}
                            </Box>
                        </Box>
                    </Box>
                ) : viewMode === "view" ? (
                    <Box>
                        <Box sx={{ borderRadius: "12px", backgroundColor: "#f8f8f8" }}>
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                variant="scrollable"
                                scrollButtons="auto"
                                allowScrollButtonsMobile
                                TabIndicatorProps={{ style: { display: "none" } }}
                                sx={{
                                    "& .MuiTab-root": {
                                        textTransform: "capitalize",
                                        color: "#BCBCBC",
                                        fontFamily: "Inter",
                                        fontSize: 15,
                                        fontStyle: "normal",
                                        fontWeight: 400,
                                        lineHeight: "30px",
                                        backgroundColor: "#f8f8f8",
                                        width: "178px",
                                        "&.Mui-selected": {
                                            backgroundColor: "white",
                                            color: "#5523D2",
                                            borderRadius: "6px 6px 0 0 !important",
                                            textAlign: "center",
                                            fontSize: 15,
                                            fontStyle: "normal",
                                            fontWeight: 600,
                                            lineHeight: "30px",
                                            borderBottom: 0,
                                            borderBottomColor: "#FAC800",
                                            borderBottomWidth: 4,
                                        },
                                    },
                                }}
                            >
                                <Tab label="Configuration" {...a11yProps(0)} />
                                <Tab label="Message Texts" {...a11yProps(1)} />
                            </Tabs>
                        </Box>
                        <CustomTabPanel value={value} index={0}>
                            <LoanTypesDetailsView data={loanTypeConfig} />
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={1}>
                            <LoanTypesDetailsView data={loanTypeMsgTexts} handleLangIdSelect={handleLangIdSelect} />
                        </CustomTabPanel>
                    </Box>
                ) : viewMode === "edit" ? (
                    <Box className="mt-4">
                        <Box className="batch-tabs">
                            <Box sx={{ width: "100%" }}>
                                {/* <Box sx={{ borderRadius: "12px", backgroundColor: "#f8f8f8" }}>
                                    <Tabs
                                        value={value}
                                        onChange={handleChange}
                                        variant="scrollable"
                                        scrollButtons="auto"
                                        allowScrollButtonsMobile
                                        TabIndicatorProps={{ style: { display: "none" } }}
                                        sx={{
                                            "& .MuiTab-root": {
                                                textTransform: "capitalize",
                                                color: "#BCBCBC",
                                                fontFamily: "Inter",
                                                fontSize: 15,
                                                fontStyle: "normal",
                                                fontWeight: 400,
                                                lineHeight: "30px",
                                                backgroundColor: "#f8f8f8",
                                                width: "178px",
                                                "&.Mui-selected": {
                                                    backgroundColor: "white",
                                                    color: "#5523D2",
                                                    borderRadius: "6px 6px 0 0 !important",
                                                    textAlign: "center",
                                                    fontSize: 15,
                                                    fontStyle: "normal",
                                                    fontWeight: 600,
                                                    lineHeight: "30px",
                                                    borderBottom: 0,
                                                    borderBottomColor: "#FAC800",
                                                    borderBottomWidth: 4,
                                                },
                                            },
                                        }}
                                    >
                                        <Tab label="Configuration" {...a11yProps(0)} />
                                    </Tabs>
                                </Box> */}
                                {/* <CustomTabPanel value={value} index={0}> */}
                                <Box alignItems="center" gap={2} sx={{ maxWidth: 1200, mt: 4, p:2, pb:4, display: 'flex', flexDirection:'row', alignItems:'flex-start' }}>
                                        <Box sx={{width: '70%'}}>
                                            <CustomLoansForm
                                                formValues={formValues}
                                                formName={"createloantypes"}
                                                buttonText={"Submit"}
                                                onSubmit={handleLoanTypeUpdate}
                                                loadingButtonText={"Creating Loan Type ..."}
                                                initialValues={selectedProduct?.loantypes}
                                                isLoanProduct={true}
                                                isEdit={true}
                                                verifyLangTagId={verifyLangTagId}
                                            />
                                        </Box>
                                    {displayLangTagDetails && 
                                        <Box sx={{ height:'100%', display:'flex', width:'30%', flexDirection:'column' }}>
                                            LangTag Details
                                            {
                                                displayLangTagDetailsArray?.map((val, idx)=> {
                                                    console.log("displayLangTagDetailsArray-------", val);
                                                    return (
                                                        <Box sx={{ marginTop:'10px', whiteSpace: 'pre-line' }}>
                                                            <Typography>{formatText(val?.langtag?.label)}</Typography>
                                                        </Box>
                                                    )
                                                })
                                            }
                                        </Box>
                                    }
                                </Box>

                                {/* </CustomTabPanel> */}
                                {/* <CustomTabPanel value={value} index={1}>
                                    <Box alignItems="center" gap={2} sx={{ maxWidth: 800, mt: 2 }}>
                                        <CustomLoansForm
                                            formValues={formValues}
                                            formName={"createloantypemessagetexts"}
                                            buttonText={"Submit"}
                                            onSubmit={handleSubmit}
                                            loadingButtonText={"Creating Loan Type ..."}
                                            initialValues={selectedProduct?.loantypes}
                                        />
                                    </Box>
                                </CustomTabPanel> */}
                            </Box>
                        </Box>
                    </Box>
                ) : viewMode === "viewLangIdTable" ? (
                    <Box>
                        <Box sx={{ borderRadius: "12px" }}>
                            <LoanLangTagsTable setAlert={setAlert} setAlertOpen={setAlertOpen} langIdTableData={langIdTableData} setViewMode={setViewMode} setValue={setValue} selectedLangId={selectedLangId} />
                        </Box>
                    </Box>
                ) : (
                    <Box className="mt-4">
                        <LoanSetupTable
                            data={loanTypesArr}
                            columns={columns}
                            title="Loan Types"
                            formatRow={(row) => [
                                row?.loantypes?.loantype,
                                row?.loantypes?.loandesc,
                                row?.loantypes?.flagging,
                                row?.loantypes?.flaggingdays,
                                row?.loantypes?.optin,
                                row?.loancategories?.isflaggedloandue
                            ]}
                            handleEdit={handleEdit}
                            handleViewDetails={handleViewDetails}
                            isEdit={true}
                            viewDetails={true}
                        />
                    </Box>
                )
            }
        </Box>
    );
    
}

export default LoanTypes;
